<template>
  <modal ref="modal">
    <modal-body :message="message" />
    <modal-footer>
      <confirm-button @click="doOk" />
    </modal-footer>
  </modal>
</template>
  
  <script>
  import Modal from "@/views/atoms/Modal";
  import ModalBody from "@/views/atoms/ModalBody";
  import ModalFooter from "@/views/atoms/ModalFooter";
  import ConfirmButton from '@/views/molecules/buttons/ConfirmButton';
  
  export default {
    name: "SuccessModal",
    components: {
      Modal,
      ModalBody,
      ModalFooter,
      ConfirmButton
    },
    props:{
        doOk:{
            type: Function,
            default:() => {}
        }
    },
    data() {
        return {
            message: '',
        }
    },
    methods: {
      show(message) {
        this.message = message
        this.$refs.modal.show(message);
      },
      hide() {
        this.$refs.modal.hide();
      },
    },
  }
  </script>
  